import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Single shared sign-in with automatic role detection.
export default function PortalRedirect() {
  const { user, checking } = useAuth();
  if (checking || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "internal") return <Navigate to="/app" replace />;
  if (user.role === "client") return <Navigate to="/client" replace />;
  if (user.role === "recruiter_partner") return <Navigate to="/partner" replace />;
  return <Navigate to="/candidate" replace />;
}
